'use client';

import { useQueryState } from 'nuqs';
import { useLayoutEffect, useRef } from 'react';
import { usePathname } from '@/i18n/routing';
import { GM_DRAWER_QUERY_KEY, gmDrawerQueryParser } from '../model/gmDrawerQuery';

export const GmDrawerRouteReset = () => {
  const pathname = usePathname();
  const [drawerView, setDrawerView] = useQueryState(GM_DRAWER_QUERY_KEY, gmDrawerQueryParser);
  // A browser Back can restore an older lobby URL with the drawer query intact.
  const visitedOtherPageRef = useRef(false);

  useLayoutEffect(() => {
    if (pathname !== '/' && pathname !== '/scratch-card') {
      visitedOtherPageRef.current = true;
      return;
    }

    if (pathname === '/' && visitedOtherPageRef.current) {
      if (drawerView !== null) {
        void setDrawerView(null);
      } else {
        visitedOtherPageRef.current = false;
      }
    }
  }, [drawerView, pathname, setDrawerView]);

  return null;
};
